import React from 'react';


const StepsList = ({ listOfSteps }) => (
  <ul>
    {listOfSteps.map((step, idx) => (
      <li key={idx}>{step}</li>
    ))}
  </ul>
);

export default StepsList;
